export default {
  conditions: {
    id: 'grades_modal_condition',
    defaultMessage: 'Conditions',
  },
  moreInfo: {
    id: 'grades_modal_more_info',
    defaultMessage: 'More info',
  },
  alternativeController: {
    id: 'alternative-controller',
    defaultMessage: 'Controller',
  },
  alternativeCurrent: {
    id: 'alternative-current',
    defaultMessage: 'Current Slide',
  },
  alternativeNext: {
    id: 'alternative-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'alternative-previous',
    defaultMessage: 'Previous',
  },
  fair1: {
    id: 'product_page_customization_condition_guidance_fair_1',
    defaultMessage: 'Has visible scratches and/or dents',
  },
  fair2: {
    id: 'product_page_customization_condition_guidance_fair_2',
    defaultMessage:
      'Your device is still guaranteed 100% functional regardless of its appearance.',
  },
  fair3: {
    id: 'product_page_customization_condition_guidance_fair_3',
    defaultMessage:
      'May have micro-scratches which could be slightly noticeable when the screen is turned on.',
  },
  good1: {
    id: 'product_page_customization_condition_guidance_good_1',
    defaultMessage: 'May have micro-scratches on the body only.',
  },
  good2: {
    id: 'product_page_customization_condition_guidance_good_2',
    defaultMessage:
      'Your device is still guaranteed 100% functional regardless of its appearance.',
  },
  good3: {
    id: 'product_page_customization_condition_guidance_good_3',
    defaultMessage: 'Screen: Perfect condition.',
  },
  excellent1: {
    id: 'product_page_customization_condition_guidance_excellent_1',
    defaultMessage: 'May have barely visible scratches on the body only.',
  },
  excellent2: {
    id: 'product_page_customization_condition_guidance_excellent_2',
    defaultMessage:
      'Your device is still guaranteed 100% functional regardless of its appearance.',
  },
  excellent3: {
    id: 'product_page_customization_condition_guidance_excellent_3',
    defaultMessage: 'Screen: Perfect condition.',
  },
}
